import { ICoreContext } from '@msdyn365-commerce/core';
import { useMemo } from 'react';
import { useSyncGenderCookie } from '../../../shared/services/gender-cookie-service/hooks/use-sync-gender-cookie';
import { isInHomePage } from '../../../shared/functions/msdyn-helpers';

import { detectGenderFromPath, getGenderUrlsForLocale } from '../../../shared/services/gender-cookie-service/gender-cookie-service';
import { ILocaleGenderUrls } from '../../../shared/services/gender-cookie-service/gender-cookie-service.types';
import { areUrlsEqual } from '../../../shared/functions/url-helpers';

export interface IUseGenderHeaderOptions {
    context: ICoreContext;
}

/**
 * Synchronizes the gender cookie from gendered homepage URLs.
 */
export const useGenderHeader = (options: IUseGenderHeaderOptions): void => {
    const { context } = options;
    const isHomepage = !!isInHomePage(context);

    const localeGenderUrls: ILocaleGenderUrls[] | undefined = context.request.app.config.localeGenderUrls;

    const genderUrlsForLocale = useMemo(
        () => getGenderUrlsForLocale(localeGenderUrls, context.request.locale),
        [localeGenderUrls, context.request.locale]
    );

    const homeUrl: string = context.request.app.routes.home.destinationUrl;
    const { pathname } = context.request.url.requestUrl;
    const isBaseHomepage = areUrlsEqual(homeUrl, pathname);
    const homepageGenderMatch =
        isHomepage && genderUrlsForLocale && !isBaseHomepage ? detectGenderFromPath(pathname, genderUrlsForLocale) : undefined;

    useSyncGenderCookie(homepageGenderMatch?.genderPath ? homepageGenderMatch.gender : undefined, context);
};
